import { getCode } from '@core/utils/codes'
import Form from '@admin/components/form'
import PropTypes from 'prop-types'
import React from 'react'

class Option extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    defaultValue: PropTypes.object,
    mode: PropTypes.string,
    options: PropTypes.array,
    onDone: PropTypes.func
  }

  state = {
    config: null
  }

  _handleBack = this._handleBack.bind(this)
  _handleChange = this._handleChange.bind(this)
  _handleDone = this._handleDone.bind(this)

  render() {
    if(!this.state.config) return null
    return <Form { ...this._getForm() } />
  }

  componentDidMount() {
    const { mode, defaultValue } = this.props
    this.setState({
      config: mode === 'edit' ? defaultValue : this._getDefault()
    })
  }

  _getDefault() {
    return {
      code: getCode(10)
    }
  }

  _getForm() {
    const { config } = this.state
    const { mode } = this.props
    return {
      title: 't(Option)',
      cancelSvg: 'chevron_left',
      onCancel: this._handleBack,
      onChange: this._handleChange,
      onSuccess: this._handleDone,
      saveText: mode === 'new' ? 'Add' : 'Update',
      sections: [
        {
          fields: [
            { name: 'code', type: 'hidden', value: config.code },
            { label: 't(Option)', type: 'segment', fields: [
              { name: 'number', type: 'numberfield', required: true, placeholder: 't(Enter Number)', maxLength: 1, defaultValue: config.number },
              { name: 'name', type: 'textfield', required: true, placeholder: 't(Enter Name)', defaultValue: config.name }
            ] }
          ]
        }
      ]
    }
  }

  _handleBack() {
    this.context.form.pop()
  }

  _handleChange(config) {
    this.setState({ config })
  }

  _handleDone() {
    const { config } = this.state
    this.props.onDone(config)
    this.context.form.pop()
  }

}

export default Option
